module.exports = __webpack_public_path__ + "static/render_night_2K_sig-beb7702958df91df9677ee10e1499e76.webp";